module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright mtop"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("Copyright © 1984 by Thomas F. Monteleone")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("Diversion Books")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("A division of Diversion Publishing Corp.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_c('a', {
    attrs: {
      "href": "http://www.diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.diversionbooks.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_vm._v("Copyright © 1984")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("First Diversion Books edition, 2020")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("eBook ISBN: 978-1-63576-760-5")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("Printed in The United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("1 3 5 7 9 10 8 6 4 2")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright mtop"
  }, [_c('span', {
    staticClass: "no-style-override-15"
  }, [_vm._v("Library of Congress cataloging-in-publication data is available on file.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24553300","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f004.vue
// module id = 69
// module chunks = 0